import React from 'react';

const WithdrawalReportSkeleton = () => {
  return (
    <div className="withdrawal-report-skeleton">

      {/* Filter Section Skeleton */}
      <div className="card border-0 shadow-sm mb-4">
        <div className="card-body">
          <div className="row align-items-center">
            <div className="col-md-3">
              <div className="skeleton-text skeleton-filter mb-2"></div>
              <div className="skeleton-select"></div>
            </div>
            <div className="col-md-3">
              <div className="skeleton-text skeleton-filter mb-2"></div>
              <div className="skeleton-select"></div>
            </div>
            <div className="col-md-4">
              <div className="skeleton-text skeleton-filter mb-2"></div>
              <div className="d-flex gap-2">
                <div className="skeleton-input flex-grow-1"></div>
                <div className="skeleton-input flex-grow-1"></div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="skeleton-button mt-4"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Withdrawal Table Skeleton */}
      <div className="card border-0 shadow-sm">
        <div className="card-header bg-white border-bottom">
          <div className="skeleton-text skeleton-table-title"></div>
        </div>
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead className="table-light">
                <tr>
                  {[...Array(8)].map((_, index) => (
                    <th key={index} className="border-0 py-3">
                      <div className="skeleton-text skeleton-th"></div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[...Array(10)].map((_, rowIndex) => (
                  <tr key={rowIndex}>
                    {[...Array(8)].map((_, colIndex) => (
                      <td key={colIndex} className="py-3">
                        <div className="skeleton-text skeleton-td"></div>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Pagination Skeleton */}
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div className="skeleton-text skeleton-pagination-info"></div>
        <div className="d-flex gap-2">
          {[...Array(5)].map((_, index) => (
            <div key={index} className="skeleton-pagination-btn"></div>
          ))}
        </div>
      </div>

      <style jsx>{`
        .withdrawal-report-skeleton {
          animation: pulse 1.5s ease-in-out infinite;
        }

        .skeleton-text, .skeleton-icon, .skeleton-select, .skeleton-input, .skeleton-button, .skeleton-pagination-btn {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 4px;
        }

        .skeleton-icon {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          flex-shrink: 0;
        }

        .skeleton-title {
          height: 16px;
          width: 70%;
        }

        .skeleton-amount {
          height: 20px;
          width: 90%;
        }

        .skeleton-filter {
          height: 14px;
          width: 60%;
        }

        .skeleton-select, .skeleton-input {
          height: 38px;
          width: 100%;
        }

        .skeleton-button {
          height: 38px;
          width: 80px;
        }

        .skeleton-table-title {
          height: 18px;
          width: 200px;
        }

        .skeleton-th {
          height: 16px;
          width: 80%;
        }

        .skeleton-td {
          height: 16px;
          width: 90%;
        }

        .skeleton-pagination-info {
          height: 16px;
          width: 150px;
        }

        .skeleton-pagination-btn {
          width: 35px;
          height: 35px;
          border-radius: 4px;
        }

        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.8;
          }
        }

        .card {
          border: 1px solid #e9ecef !important;
        }

        .table th, .table td {
          border-color: #e9ecef;
        }
      `}</style>
    </div>
  );
};

export default WithdrawalReportSkeleton;
